// The line pictograms for the catalog's muscle groups (muscleGroup) and equipment (equipmentCategory): the same
// drawings the AI builder shows for its choices, so an exercise's "muscle · equipment" line carries them too.
// "other" has no drawing of its own and shows the word alone.
import abs from '../assets/abs.png';
import back from '../assets/back.png';
import biceps from '../assets/biceps.png';
import calves from '../assets/calves.png';
import chest from '../assets/chest.png';
import forearms from '../assets/forearms.png';
import glutes from '../assets/glutes.png';
import hamstrings from '../assets/hamstrings.png';
import legs from '../assets/legs.png';
import lowback from '../assets/lowback.png';
import quads from '../assets/quads.png';
import shoulder from '../assets/shoulder.png';
import traps from '../assets/traps.png';
import triceps from '../assets/triceps.png';
import various from '../assets/various.png';
import barbell from '../assets/barbell.png';
import bands from '../assets/bands.png';
import pullupbar from '../assets/pullupbar.png';
import dumbbells from '../assets/dumbbells.png';
import kettlebell from '../assets/kettlebell.png';
import station from '../assets/station.png';
import trainingbands from '../assets/trainingbands.png';
import weightplates from '../assets/weightplates.png';

export const MUSCLE_ICONS = {
  abdominals: abs,
  abductors: glutes,
  adductors: legs,
  biceps,
  calves,
  cardio: various,
  chest,
  forearms,
  full_body: various,
  glutes,
  hamstrings,
  lats: back,
  lower_back: lowback,
  neck: traps,
  quadriceps: quads,
  shoulders: shoulder,
  traps,
  triceps,
  upper_back: back,
};

export const EQUIPMENT_ICONS = {
  bar: pullupbar,
  barbell,
  dumbbell: dumbbells,
  kettlebell,
  machine: station,
  none: various,
  plate: weightplates,
  resistance_band: bands,
  suspension: trainingbands,
};
